/** @format */

import { Component, input } from '@angular/core';

@Component({
	selector: 'plp-components-category-bubble',
	templateUrl: './category-bubble.component.html',
	styleUrl: './category-bubble.component.scss',
	standalone: true
})
export class CategoryBubbleComponent {
	image = input.required<string>();
	link = input.required<string>();

	altText = input('');
	label = input('');
}
